const BeautyAutopilot = () => import('./views/BeautyAutopilot.vue')
const TaskLibrary = () => import('./views/TaskLibrary.vue')

export default [
    {
        path: '/project/:id/GCB2/BeautyAutopilot',
        name: 'BeautyAutopilot',
        component: BeautyAutopilot,
        requiresBeautyAutopilot: true,
    },
    {
        path: '/project/:id/GCB2/BeautyAutopilot/task-library',
        name: 'BeautyAutopilotTaskLibrary',
        component: TaskLibrary,
        requiresBeautyAutopilot: true,
        // «Библиотека задач» — функция «Оптимы».
        requiresBeautyAutopilotOptima: true,
    },
]
